module.exports = __webpack_public_path__ + "img/dab_sedziwy_bis.05f521df.jpg";